@switch(type$ | async){ @case(dialogType.OVERVIEW){
<notification-overview-dialog></notification-overview-dialog>
} @case(dialogType.DETAIL){
<notification-detail-dialog></notification-detail-dialog>
} }
